import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { ReactNode } from "react";

type Props = {
	leftActions: ReactNode;
	icon: ReactNode;
	content: ReactNode;
	rightActions: ReactNode;
	created: string;
};

export function Layout({
	leftActions,
	icon,
	content,
	rightActions,
	created,
}: Props) {
	return (
		<Box sx={{ width: "100%" }}>
			<Stack direction="row" alignItems="center" gap={1}>
				<Box sx={{ flex: "none", minWidth: "20px" }}>{leftActions}</Box>
				{icon}
				<Box sx={{ minWidth: 0 }}>{content}</Box>
				<Box flex={1} />
				<Stack alignItems="end" alignSelf="stretch">
					{rightActions}
					<Box flex={1} />
					<Typography fontSize={12} color="gray" fontWeight={500}>
						{dayjs(created).format("MM/DD/YYYY hh:mm:ss")}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
}
